import {StrictMode} from 'react';
import {render} from '@wordpress/element';

/**
 * Import the stylesheet for the plugin.
 */
import {AppStore} from "./components/AppStore";

// Render the App component into the DOM
render(
    <StrictMode>
        <AppStore/>
    </StrictMode>
    , document.getElementById('shop-page-root')
);